import { useTranslation } from 'react-i18next';
import Widget from '../../../../../../../../Analysis/widget';
import Chart, { getColors } from '../../../../../../../../Analysis/components/scl-components/stack-chart';
import useIncidentsTimeline from './hook';
import moment from 'moment';
import { renderTooltipJsx } from 'datastake-daf/dist/utils';
import Tooltip from '../problem-solvers/tooltip';
import { useApp } from '../../../../../../../../../helpers/user';

export default function IncidentsTimeline({ filter, data = [], loading }) {
  const { t } = useTranslation();
  const { filtersConfig } = useIncidentsTimeline();
  const isEmpty = !data.length;
  const app = useApp();

  const renderSeverity = (val) => {
    const colors = getColors('INCIDENTS', app);

    switch (val) {
      case 'major':
        return <span style={{ color: colors.major }}>{t('Major')}</span>;
      case 'minor':
        return <span style={{ color: colors.minor }}>{t('Minor')}</span>;
      case 'moderate':
        return <span style={{ color: colors.moderate }}>{t('Moderate')}</span>;
      default:
        return null;
    }
  };

  return (
    <Widget
      loading={loading}
      filtersConfig={filtersConfig}
      title={t('Events Timeline')}
      className="with-border-header">

      <div className="mb-4 flex-1 flex flex-column justify-content-center">
        <Chart
          pastWeeks={11}
          defaultDateKey="date"
          data={data}
          period={filter === '3' ? 'weekly' : 'monthly'}
          type="INCIDENTS"
          doConstraints={false}
          renderTooltip={(ev) => {
            if (isEmpty) {
              const { mouseX, mouseY } = ev;

              return (
                <Tooltip
                  mouseX={mouseX}
                  mouseY={mouseY}
                >
                  {renderTooltipJsx({
                    title: t('Risk Types'),
                    subTitle: '--',
                    items: [
                      {
                        label: t('Source'),
                        value: '--',
                      },
                      {
                        label: t('Severity'),
                        value: '--',
                      },
                    ]
                  })}
                </Tooltip>
              )
            }

            return renderTooltipJsx({
              title: ev.name,
              className: 'pt-1 pb-1',
              link: `/app/tazama/view/incidents/${ev.datastakeId}`,
              subTitle: moment(ev.date).format('DD MMM YYYY'),
              items: [
                {
                  label: t('Source'),
                  value: ev?.source || '--',
                },
                ev.incidentSeverity ? {
                  label: t('Severity'),
                  value: renderSeverity(ev.incidentSeverity),
                } : null,
              ].filter((e) => !!e)
            });
          }}
        />
      </div>

    </Widget>
  );
}
